export default {
  // 交易方向
  transactionDirection: "交易方向：",
  inflow: "流入",
  outflow: "流出",
  bidirectional: "雙向",

  // 交易方向提示
  inflowTooltip: "節點向流入的方向擴展",
  outflowTooltip: "節點向流出的方向擴展",
  bidirectionalTooltip: "節點向流入和流出的方向同時擴展",

  // 節點操作
  nodeOperation: "節點操作：",
  directAssociation: "直接關聯",
  batchExpansion: "批量擴展",
  batchBalanceQuery: "批量餘額查詢",
  commonCounterparty: "共同交易對手",
  exchangeExpansion: "交易所擴展",

  // 節點操作提示
  directAssociationTooltip: "所選節點之間的交易關係",
  batchExpansionTooltip: "批量擴展所選節點",
  batchBalanceQueryTooltip: "批量查詢所選節點的餘額",
  commonCounterpartyTooltip:
    "共同交易對手:分析多個地址共同流入或共同流出的交易對手",
  exchangeExpansionTooltip: "交易所擴展:擴展單個地址流入或流出到交易所的聚合點",

  // AI模型
  aiModel: "AI模型：",
  firstFeeTraceability: "首筆手續費追溯",
  multilayerTraceability: "多層追溯",
  transactionPathAnalysis: "交易路徑分析",
  newOldStopModel: "新啟舊停模型",
  singleChannelModel: "單通道中轉模型",

  // AI模型提示
  firstFeeTraceabilityTooltip: "首筆手續費追溯:追溯單個地址5級之內的交易所地址",
  multilayerTraceabilityTooltip:
    "多層追溯: 追溯流單個地址最多3級之內的轉入或者轉出交易路徑",
  transactionPathAnalysisTooltip:
    "交易路徑分析:分析2級內多個起始地址到終點地址中的途徑點和交易路徑",
  newOldStopModelTooltip:
    "新啟舊停模型:用於分析黑灰產地址的遷移行為。用戶可指定目標地址與篩選條件，系統將自動檢索該地址的最早或最新一筆交易，識別地址啟用或停用狀態。模型可發現黑灰產在更換收款地址時的整筆資金轉移，有助於追蹤其最新活躍地址或反向查找歷史地址，為鏈上追蹤與風險分析提供關鍵線索。",
  singleChannelModelTooltip:
    "單通道中轉模型:該模型用於識別黑灰產資金轉移過程中的中轉行為。系統會以指定地址為起點，逐層分析其資金流入和流出關係，尋找資金流高度集中的地址鏈路。模型會沿著這類高依賴的轉移路徑持續追蹤，直到資金出現分散流動，從而揭示黑灰產資金的主要中轉路徑。",

  // 成功消息
  directionModifiedSuccess: "轉賬方向修改成功",
};
